<template>
  <div
    ref="rootRef"
    popover="manual"
    :class="DS_FEATURE_HINT_CLASSES.Spotlight"
    data-cy="ds-feature-hint__spotlight"
  >
    <div
      :class="DS_FEATURE_HINT_CLASSES.SpotlightBackdrop"
      :style="backdropStyle"
      data-cy="ds-feature-hint__spotlight-backdrop"
      @click="emit('click')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, ref } from "vue";
import type { DSFeatureHintSpotlightProps } from "@/src/design_system/feedback/feature_hint/types/spotlightProps";
import { DS_FEATURE_HINT_CLASSES } from "@/src/design_system/feedback/feature_hint/constants/classes";
import {
  calculateSpotlightHole,
  spotlightClipPath,
  type SpotlightHole,
} from "@/src/design_system/feedback/feature_hint/utils/spotlight";

const props = defineProps<DSFeatureHintSpotlightProps>();
const emit = defineEmits<{ click: [] }>();

const rootRef = ref<HTMLElement>();
const hole = ref<SpotlightHole | null>(null);
const backdropStyle = computed(() => (hole.value ? { clipPath: spotlightClipPath(hole.value) } : undefined));

const update = () => {
  if (!props.anchorElement) return;

  hole.value = calculateSpotlightHole(props.anchorElement.getBoundingClientRect());
};

// Shown before the card's popover so that it stays below the card in the top layer.
const show = () => {
  try {
    rootRef.value?.showPopover();
  } catch {
    // Already shown — no-op
  }
};

const hide = () => {
  try {
    rootRef.value?.hidePopover();
  } catch {
    // Already hidden — no-op
  }
  hole.value = null;
};

onBeforeUnmount(hide);

defineExpose({ show, hide, update });
</script>
